import React from 'react';

export default ({ children, ...props }) => <div id="dropdown">{children}</div>;
